var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-item__content--table"},[_c('div',{staticClass:"table",on:{"click":_vm.clickLink}},[(_vm.url)?_c('img',{staticClass:"table__snapshot viewer",style:({
                width: (_vm.totalWidth + "px")
            }),attrs:{"src":_vm.url},on:{"click":_vm.previewImage}}):_c('table',{ref:"table",style:({
                width: _vm.isMobile ? (_vm.totalWidth + "px") : 'auto'
            })},_vm._l((_vm.newtable),function(tr,trIndex){return _c('tr',{key:trIndex},_vm._l((tr),function(td,tdIndex){return _c('td',{key:tdIndex,class:{       
                        'acolor': _vm.showcolor
                    },style:({
                        width: ((_vm.colWidths[tdIndex]) + "px")
                    }),domProps:{"innerHTML":_vm._s(td)}})}),0)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }